import React, { useEffect, useState } from "react";
import Logo from "../../assets/imgs/psglogo.webp";
import Hmenu from "../../assets/imgs/psglogo2.webp";
import $ from "jquery";
import SideNavigation from "../Menu-sidenavbar/SideNavigation ";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MarqueeText from "../../common/marquee";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
// import Search from "../../common/Search";
// import { useLocation, } from "react-router-dom";
// import { routes } from "../../routes/routes";
import {
  faAddressBook,
  faSuitcase,
  faGlobe,
  faBook,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";

// const { SubMenu } = Menu;

const Header = ({ Color, isInGallery, isInProject, charityLink }) => {
  const [showTooltip, setShowTooltip] = useState(false); // Controls the tooltip visibility

  const handleMouseEnter = () => setShowTooltip(true); // Show tooltip on hover
  const handleMouseLeave = () => setShowTooltip(false); // Hide tooltip when mouse leaves
  const handleClick = () => setShowTooltip(false); // Hide tooltip on click

  const handleSocialToggle = () => {
    setIsSocialOpen((prev) => !prev); // Toggle the social links
  };

  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
  const [isSocialOpen, setIsSocialOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 300);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    $(".navbar .search-form").on("click", ".search-icon", function () {
      $(".navbar .search-form").toggleClass("open");

      if ($(".navbar .search-form").hasClass("open")) {
        $(".search-form .close-search").slideDown();
      } else {
        $(".search-form .close-search").slideUp();
      }
    });

    $(".navbar").on("click", ".navbar-toggler", function () {
      $(".navbar .navbar-collapse").toggleClass("show");
    });

    $(window).on("scroll", function () {
      var bodyScroll = window.scrollY,
        navbar = $(".navbar"),
        logo = $(".navbar.change .logo > img");

      if (bodyScroll > 300) {
        navbar.addClass("nav-scroll");
        logo.attr("src", "assets/imgs/logo-dark.png");
      } else {
        navbar.removeClass("nav-scroll");
        logo.attr("src", "assets/imgs/logo-light.png");
      }
    });

    // Clean up jQuery events
    return () => {
      $(".navbar .search-form").off("click", ".search-icon");
      $(".navbar").off("click", ".navbar-toggler");
      $(window).off("scroll");
    };
  }, []);

  const handleMenuItemClick = (event) => {
    const submenu = event.target.nextSibling;
    if (submenu && submenu.classList.contains("sub-menu")) {
      submenu.classList.toggle("show");
    }
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleSubMenu = () => {
    setIsOpen(!isOpen);
  };

  const { Footerdata } = useSelector((state) => state.FooterReducer);

  return (
    <>
      <nav
        className={`navbar ${isScrolled ? "nav-scroll" : ""} ${
          isInGallery ? "gallery-navbar" : ""
        }`}
      >
        {/* {/ Top section /} */}
        <div className="top-men">
          <div className="container-fluid">
            <div className="row align-items-center">
              <MarqueeText />
            </div>
          </div>
        </div>
        {/* 
        {/ Logo, Search Form, and Menu /} */}
        <div className="container h-top logo-socialicon">
          {/* {/ Logo /} */}
          <a className="logo " href="/">
            {isInGallery ? (
              <img
                src={Hmenu}
                alt="logo"
                className="res-logo1"
                loading="lazy"
              />
            ) : (
              <img
                src={isScrolled ? Hmenu : Logo}
                alt="logo"
                className="res-logo updated-logo"
                loading="lazy"
              />
            )}
          </a>
          {/* {/ Search Form /} */}
          {/* <div className="search-form ml-auto">
            <div className="form-group">
              <input type="text" name="search" placeholder="Search" />
              <button>
                <span className="pe-7s-search"></span>
              </button>
            </div>
            <div className="search-icon" style={{ color: Color }}>
              <span className="pe-7s-search open-search"></span>
              <span className="pe-7s-close close-search"></span>
            </div>
          </div> */}
          {/*           
          <Search
            routes={Object.keys(routes).map((name) => ({
              name,
              path: routes[name],
            }))}
            navigate={navigate}
            handleMenuToggle={handleMenuToggle}
          /> */}
          {/* {/ Menu /} */}
          <div className="topnav d-flex">
            <li
              className="hover-this cursor-pointer header-icons h-library-icon"
              data-tooltip="Library"
            >
              <a
                href="http://library.psgiap.ac.in/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: isScrolled || isInGallery ? "black" : "",
                }}
                className={isScrolled || isInGallery ? "" : "white"}
              >
                <motion.div whileHover={{ scale: 1.6 }}>
                  <FontAwesomeIcon
                    style={{
                      marginRight: "25px",
                      height: "15px",
                      width: "16px",
                    }}
                    icon={faBook}
                  />
                </motion.div>
              </a>
            </li>
            <li
              className="hover-this cursor-pointer header-icons h-work-icon"
              data-tooltip="Work with us"
            >
              <Link
                to="/work-with-us"
                style={{
                  color: isScrolled || isInGallery ? "black" : "",
                }}
                className={isScrolled || isInGallery ? "" : "white"}
              >
                <motion.div whileHover={{ scale: 1.6 }}>
                  <FontAwesomeIcon icon={faSuitcase} />
                </motion.div>
              </Link>
            </li>

            <li
              className="hover-this cursor-pointer header-icons h-contact-icon"
              data-tooltip="Connect with us"
            >
              <Link
                to="/ConnectWithus"
                style={{
                  color: isScrolled || isInGallery ? "black" : "",
                }}
                className={isScrolled || isInGallery ? "" : "white"}
              >
                <motion.div whileHover={{ scale: 1.6 }}>
                  <FontAwesomeIcon icon={faAddressBook} />
                </motion.div>
              </Link>
            </li>
            <div
              className="menu-icon cursor-pointer res-menu1"
              style={{ color: Color }}
              onClick={handleMenuToggle}
            >
              <span className="icon ti-menu" style={{ color: Color }}></span>
              Menu
            </div>

            <div className="social-container" style={{ position: "relative" }}>
              <div
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onClick={() => {
                  handleSocialToggle();
                  handleClick();
                }}
                className="cursor-pointer social-toggle-icon hover-this h-social-links"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  marginRight: "5px",
                  position: "relative",
                  textDecoration: "none",
                  border: "none",
                  outline: "none",
                }}
              >
                {/* Tooltip */}
                {showTooltip && (
                  <span
                    className="globe-icon-res"
                    style={{
                      position: "absolute",
                      top: "100%",
                      marginTop: "30px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      backgroundColor: "#000",
                      color: "#fff",
                      padding: "5px",
                      borderRadius: "3px",
                      whiteSpace: "nowrap",
                      fontSize: "12px",
                      zIndex: 1000,
                    }}
                  >
                    Social links
                  </span>
                )}
                <FontAwesomeIcon
                  icon={faGlobe}
                  style={{
                    color: isScrolled || isInGallery ? "black" : "",
                  }}
                  className={isScrolled || isInGallery ? "" : "white"}
                />
                <FontAwesomeIcon
                  icon={isSocialOpen ? faChevronUp : faChevronDown}
                  style={{
                    color: isScrolled || isInGallery ? "black" : "",
                    fontSize: "0.6rem",
                  }}
                  className={isScrolled || isInGallery ? "" : "white"}
                />
              </div>

              {/* Social Links */}
              {isSocialOpen && (
                <ul
                  className="social-icons"
                  style={{
                    position: "absolute",
                    top: "70%",
                    left: "5px",
                    marginTop: "5px",
                  }}
                >
                  {Footerdata?.Social_links?.map((social, index) => {
                    const updatedSocial = {
                      ...social,
                      youtube: social.youtube || "https://youtube.com/psgiap",
                    };

                    return (
                      <React.Fragment key={index}>
                        {updatedSocial.facebook && (
                          <li className="hover-this cursor-pointer">
                            <a
                              href={updatedSocial.facebook}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: isScrolled || isInGallery ? "black" : "",
                              }}
                              className={
                                isScrolled || isInGallery ? "" : "white"
                              }
                            >
                              <motion.i
                                className="fab fa-facebook-f"
                                whileHover={{ scale: 1.6 }}
                              />
                            </a>
                          </li>
                        )}
                        {updatedSocial.linkedin && (
                          <li className="hover-this cursor-pointer">
                            <a
                              href={updatedSocial.linkedin}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: isScrolled || isInGallery ? "black" : "",
                              }}
                              className={
                                isScrolled || isInGallery ? "" : "white"
                              }
                            >
                              <motion.i
                                className="fab fa-linkedin-in"
                                whileHover={{ scale: 1.6 }}
                              />
                            </a>
                          </li>
                        )}
                        {updatedSocial.instagram && (
                          <li className="hover-this cursor-pointer">
                            <a
                              href={updatedSocial.instagram}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: isScrolled || isInGallery ? "black" : "",
                              }}
                              className={
                                isScrolled || isInGallery ? "" : "white"
                              }
                            >
                              <motion.i
                                className="fab fa-instagram"
                                whileHover={{ scale: 1.6 }}
                              />
                            </a>
                          </li>
                        )}
                        {/* {updatedSocial.twitter && (
                          <li className="hover-this cursor-pointer">
                            <a
                              href={updatedSocial.twitter}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: isScrolled || isInGallery ? "black" : "",
                              }}
                              className={
                                isScrolled || isInGallery ? "" : "white"
                              }
                            >
                              <motion.i
                                className="fab fa-twitter"
                                whileHover={{ scale: 1.6 }}
                              />
                            </a>
                          </li>
                        )} */}
                        {updatedSocial.youtube && (
                          <li className="hover-this cursor-pointer">
                            <a
                              href={updatedSocial.youtube}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: isScrolled || isInGallery ? "black" : "",
                              }}
                              className={
                                isScrolled || isInGallery ? "" : "white"
                              }
                            >
                              <motion.i
                                className="fab fa-youtube"
                                whileHover={{ scale: 1.6 }}
                              />
                            </a>
                          </li>
                        )}
                      </React.Fragment>
                    );
                  })}
                </ul>
              )}
            </div>
          </div>
        </div>
      </nav>

      <SideNavigation
        isMenuOpen={isMenuOpen}
        handleMenuToggle={handleMenuToggle}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
      />
    </>
  );
};

export default Header;
